export const SUPPORTED_LOCALES = ['pt', 'en', 'es', 'de', 'fr', 'it', 'nl', 'pl', 'zh', 'hi', 'ar', 'ja'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_TAGS: Readonly<Record<SupportedLocale, string>> = {
  pt: 'pt-BR', en: 'en-US', es: 'es-419', de: 'de-DE', fr: 'fr-FR', it: 'it-IT', nl: 'nl-NL',
  pl: 'pl-PL', zh: 'zh-CN', hi: 'hi-IN', ar: 'ar', ja: 'ja-JP',
};

export function normalizeLocale(language: unknown): SupportedLocale | undefined {
  if (typeof language !== 'string') return undefined;
  const base = language.trim().toLowerCase().split('-')[0];
  return SUPPORTED_LOCALES.find((locale) => locale === base);
}

export function localeDirection(locale: SupportedLocale): 'ltr' | 'rtl' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}
